export default __webpack_public_path__ + "static/media/SELLO_SEMILLAS_CERTIFICADAS_EN.6ca0510e.png";